import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TextImageSmall as Original } from 'components/organisms'
import { TextImageSmallSettings, TextImageSmallFloatingSettings } from './TextImageSmallSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import { getTextEditor } from '../TextEditor'

export const defaultProps = {
  ...ctaDefaultProps('', ''),
  ...imageDefaultProps(),
  theme: 'neutrallight',
}

export const textImageSmallItemParams = (enabled, id, blockProps, children) => ({
  ...ctaItemParams(blockProps, enabled),
  ...imageItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const TextImageSmall: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-text-image-small ${props.className}`}>
        <Original
          item={textImageSmallItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TextImageSmall.craft = withCraft({
  name: 'TextImageSmall',
  defaultProps: defaultProps,
  settings: TextImageSmallSettings,
  floatingSettings: TextImageSmallFloatingSettings,
})
